import React from "react";
import {Button, Modal, ModalHeader, ModalBody} from "reactstrap";

export default function CustomModal({ show, tip, setTip, name, setName, phone, setPhone, email, setEmail, onClose, onSubmit}) {
    return (
        <div>
            <Modal isOpen={show} toggle={onClose}>
                <ModalHeader onClose={onClose}>Submit a Crime Tip</ModalHeader>
                <ModalBody>
                    <form onSubmit={onSubmit}>
                        <div className="form-group">
                            <label htmlFor="tip">Tip</label>
                            <textarea
                                className="form-control"
                                id="tip"
                                required
                                value={tip}
                                onChange={(e) => setTip(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="name">Name (Optional)</label>
                            <input
                                className="form-control"
                                id="name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="phone">Phone (Optional)</label>
                            <input
                                type="tel"
                                className="form-control"
                                id="phone"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Email address (Optional)</label>
                            <input
                              type="email"
                              className="form-control"
                              id="email"
                              placeholder="name@example.com"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        <Button color="primary" type="submit" value="Submit">
                            Submit
                        </Button>
                        {" "}
                        <Button color="danger" onClick={onClose}>
                            Cancel
                        </Button>
                    </form>
                </ModalBody>
            </Modal>
        </div>
    );
}